/** Normalize a single tag: trim, strip leading #, empty → null. */
export function normalizeTagInput(raw: string): string | null {
  const stripped = raw.trim().replace(/^#+/, '').trim()
  return stripped.length ? stripped : null
}

export function tagAlreadyExists(tags: string[], candidate: string): boolean {
  const lower = candidate.toLowerCase()
  return tags.some((t) => t.trim().toLowerCase() === lower)
}
